import { BaseTypeahead } from '../interfaces/typeahead';

/**
 * Reduce a react-select selection to its underlying value(s): an array of
 * values for a multi-select, or the single `value` for a single select.
 */
export const reduceValue = (
    selection: BaseTypeahead | BaseTypeahead[] | null | undefined,
): unknown => {
    if ((selection ?? {}).constructor === Array) {
        return (selection as BaseTypeahead[]).map((x) => x.value);
    }
    return ((selection ?? {}) as BaseTypeahead).value;
};
